module.exports = __webpack_public_path__ + "static/media/networking.6b7c20c9.jpg";